import React from 'react';
import './experience.css';
import experiance from '../../assets/data.json';

const Experience = () => {
    return (
        <section id="experience">
            <h2 className="experienceTitle">Work Experience</h2>
            <div className="experienceWrapper">
                    {experiance.experience.map((exp) => (
                    <div key={exp.id} className="experienceItem">
                        <h3>{exp.title}</h3>
                        <h4>{exp.company}</h4>
                        <img src={exp.image} alt={exp.company} className="companyLogo" />
                        <p className="experienceDate">{exp.date}</p>
                        <ul className="experienceList">
                            {exp.responsibilities.map((responsibility, index) => (
                                <li key={index}>{responsibility}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Experience;
